/* eslint-disable no-underscore-dangle */
import { ANADIR_CLASE, SELECCIONAR_SOCIO } from 'constants/defaultConstants';
import documentTypes from 'constants/documentTypes';
import eventTypes from 'constants/eventTypes';
import fileTypes from 'constants/fileTypes';
import { numberFormat } from 'constants/formats';
import operationTypes from 'constants/operationTypes';
import transactionTypes from 'constants/transactionTypes';
import { format } from 'date-fns';
import { useTranslate } from 'hooks/useTranslate';
import { cloneDeep } from 'lodash';
import alertBodyTypes from 'modules/_shared/components/Alert/alertBodyTypes';
import CommentsCharCounter from 'modules/_shared/components/CommentsCharCounter';
import { addAlert } from 'modules/_shared/redux/alertActions';
import { setModal } from 'modules/_shared/redux/modalActions';
import { reclassificationAction } from 'modules/_shared/redux/modalsActions';
import { addDocument } from 'modules/documents/redux/documentActions';
import AddClassEmbedded from 'modules/partners/components/AddClassEmbedded';
import UploadDocument from 'modules/documents/components/UploadDocument';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useMixpanel } from 'react-mixpanel-browser';
import NumberFormat from 'react-number-format';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { store } from 'redux/store';
import cleanText from 'utils/cleanText';
import { getActualPartner } from 'utils/filters';
import trackEvent from 'utils/trackEvent';
import AddNumerationEmbedded from '../AddNumerationEmbedded';
import '../Modals.scss';

const DECREMENT = 'DECREMENT';
const distribution = {
  BYCLASSES: 'BYCLASSES',
  BYPARTNER: 'BYPARTNER',
};

function ReclassificationModal() {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const mixpanel = useMixpanel();
  const { user } = useSelector((state) => state);
  const { holdingClasses } = useSelector((state) => state);
  const { actualSociety } = useSelector((state) => state.society);

  const [step, setStep] = useState(0);

  const [actualFrom, setActualFrom] = useState();
  const [numerationRefs, setNumerationRefs] = useState();

  const [date, setDate] = useState('');
  const [lastOperationDate, setLastOperationDate] = useState();
  const [operationDate, setOperationDate] = useState();
  const [operationLimit, setOperationLimit] = useState();

  const [file, setFile] = useState();
  const [comments, setComments] = useState('');
  const [notaryName, setNotaryName] = useState('');
  const [notaryCity, setNotaryCity] = useState('');
  const [protocolNr, setProtocolNr] = useState('');

  const [selectedPartner, setSelectedPartner] = useState(SELECCIONAR_SOCIO);
  const [partnerName, setPartnerName] = useState();

  const [distributionType, setDistributionType] = useState();

  const [renumerations, setRenumerations] = useState([]);

  const [currentPartnerShares, setCurrentPartnerShares] = useState([]);
  const [partnersShares, setPartnersShares] = useState();
  const [editIndex, setEditIndex] = useState();
  const [errorMessage, setErrorMessage] = useState('');

  const [classesRanges, setClassesRanges] = useState();
  const [currentClassRanges, setCurrentClassRanges] = useState([]);
  const [classesOptions, setClassesOptions] = useState([]);
  const [selectedClassOption, setSelectedClassOption] = useState({
    value: '',
    label: t('Select'),
  });
  const [fixedRange, setFixedRange] = useState({ from: '', to: '' });
  const [isValidRange, setIsValidRange] = useState(false);
  const [validationMessage, setValidationMessage] = useState('');
  const [selectedClassForFixedRange, setSelectedClassForFixedRange] = useState({
    value: '',
    label: t('Select'),
  });
  const [includeAllRanges, setIncludeAllRanges] = useState(false);

  const [partnerOptions, setPartnerOptions] = useState([]);
  const [selectedPartnerOption, setSelectedPartnerOption] = useState({
    value: SELECCIONAR_SOCIO,
    label: SELECCIONAR_SOCIO,
  });

  const [createClassInsite, setCreateClassInsite] = useState(false);

  const animatedComponents = makeAnimated();

  const handlePartnerOptionChange = (selectedOption) => {
    setSelectedPartner(selectedOption.value);
    setSelectedPartnerOption(selectedOption);
  };

  const handleFixedRange = (value, side) => {
    const newFixedRange = cloneDeep(fixedRange);
    if (side === 'FROM') {
      newFixedRange.from = +value;
    }
    if (side === 'TO') {
      newFixedRange.to = +value;
    }
    const isValidFrom = currentClassRanges.some(
      (share) => share.shareFrom === newFixedRange.from
    );
    const isValidTo = currentClassRanges.some(
      (share) => share.shareTo === newFixedRange.to
    );

    // validate range
    if (newFixedRange.from !== '' && newFixedRange.to !== '') {
      if (+newFixedRange.to < +newFixedRange.from) {
        setIsValidRange(false);
        setValidationMessage(t('InvalidRangeOrder'));
      } else if (!isValidFrom) {
        setIsValidRange(false);
        setValidationMessage(
          t('InvalidFromValue', { value: newFixedRange.from })
        );
      } else if (!isValidTo) {
        setIsValidRange(false);
        setValidationMessage(t('InvalidToValue', { value: newFixedRange.to }));
      } else {
        setIsValidRange(true);
        setValidationMessage('');
      }
    } else {
      setIsValidRange(false);
    }
    setFixedRange(newFixedRange);
  };

  const reclassifyFixedRange = () => {
    const shareClass = holdingClasses?.find(
      (currClass) => currClass['_id'] === selectedClassForFixedRange.value
    );
    const newShares = currentClassRanges.map((share) => {
      if (
        share.shareFrom >= +fixedRange.from &&
        share.shareTo <= +fixedRange.to
      ) {
        const newShare = {
          ...share,
          shareClass: shareClass || share?.shareClass,
        };
        return newShare;
      }
      return share;
    });
    setCurrentClassRanges(newShares);
    const newClassesRanges = cloneDeep(classesRanges);
    newClassesRanges[selectedClassOption.value] = [...newShares];
    setClassesRanges(newClassesRanges);
    const newRenumeration = {
      from: fixedRange.from,
      to: fixedRange.to,
      previous: selectedClassOption?.label || '',
      next: shareClass?.name || '',
    };
    setRenumerations([...renumerations, newRenumeration]);
  };

  const handleDate = (selectedDate) => {
    const objDate = new Date(selectedDate);
    if (objDate.getFullYear() < 1970) {
      if (operationDate) setOperationDate();
    } else if (objDate > new Date(lastOperationDate)) {
      setErrorMessage('');
      setDate(objDate);
      setOperationDate(format(objDate, 'yyyy-MM-dd'));
    } else {
      const nextDate = new Date(lastOperationDate);
      nextDate.setMinutes(nextDate.getMinutes() + 30);
      setDate(nextDate);
      setOperationDate(format(nextDate, 'yyyy-MM-dd'));
    }
  };

  const checkOverlappingShares = (shares) => {
    const compareFunction = (a, b) => +a.from - +b.from;
    const numerationGroups = shares.reduce((acc, share) => {
      const currentClass = share.shareClass;
      if (acc[numerationRefs[currentClass]])
        acc[numerationRefs[currentClass]] = [
          ...acc[numerationRefs[currentClass]],
          share,
        ];
      else acc[numerationRefs[currentClass]] = [share];
      return acc;
    }, {});

    const shareGroups = Object.values(numerationGroups);
    for (let i = 0; i < shareGroups.length; i += 1) {
      const orderedShares = shareGroups[i].sort(compareFunction);
      for (let j = 0; j < orderedShares.length - 1; j += 1) {
        if (+orderedShares[j].to >= +orderedShares[j + 1].from) return false;
      }
    }
    return true;
  };

  function getPartnersShares() {
    const movements = [];
    const transactions = [];
    const ranges = [];
    Object.entries(partnersShares).forEach(([partnerId, shares]) => {
      const partner = getActualPartner(actualSociety, partnerId);
      shares.forEach((share) => {
        movements.push({
          partner: partner['_id'],
          shareFrom: +share.shareFrom,
          shareTo: +share.shareTo,
          sharePremium: share.sharePremium,
          shareClass: share.shareClass['_id'],
          sharePrice: share.sharePrice,
          operation: 'THIS',
        });
        transactions.push({
          partner: partner['_id'],
          shareFrom: +share.shareFrom,
          shareTo: +share.shareTo,
          sharePremium: share.sharePremium,
          shareClass: share.shareClass['_id'],
          sharePrice: share.sharePrice,
          transactionType: transactionTypes.RECLASSIFICATION,
        });
        ranges.push({
          from: +share.shareFrom,
          to: +share.shareTo,
          shareClass: share.shareClass['_id'],
        });
      });
    });
    return {
      movements,
      transactions,
      ranges,
    };
  }

  function getClassesShares() {
    const movements = [];
    const transactions = [];
    Object.entries(classesRanges).forEach(([, shares]) => {
      shares.forEach((share) => {
        movements.push({
          partner: share.partner,
          shareFrom: +share.shareFrom,
          shareTo: +share.shareTo,
          sharePremium: share.sharePremium,
          shareClass: share.shareClass['_id'],
          sharePrice: share.sharePrice,
          operation: 'THIS',
        });
        transactions.push({
          partner: share.partner,
          shareFrom: +share.shareFrom,
          shareTo: +share.shareTo,
          sharePremium: share.sharePremium,
          shareClass: share.shareClass['_id'],
          sharePrice: share.sharePrice,
          transactionType: transactionTypes.RECLASSIFICATION,
        });
      });
    });
    return {
      movements,
      transactions,
    };
  }

  async function saveReclassification() {
    let uploadedDocument = null;

    if (file) {
      const newDocument = {
        file,
        date,
        size: file.size,
        name: operationTypes.RENUMERATION_FILENAME,
        author: user['_id'],
        society: actualSociety['_id'],
        fileType: fileTypes[file.type],
        category: documentTypes.SCRIPTURES,
        description: t('DocumentLinkedToOperation'),
      };
      uploadedDocument = await store.dispatch(addDocument(newDocument));
    }
    let finalMovements = [];
    let finalTransactions = [];
    if (distributionType === distribution.BYPARTNER) {
      const { movements, transactions, ranges } = getPartnersShares();
      if (!checkOverlappingShares(ranges)) {
        dispatch(addAlert(alertBodyTypes['INVALID_NUMERATIONS']));
        setDistributionType(distribution.BYCLASSES);
        return;
      }
      finalMovements = movements;
      finalTransactions = transactions;
    } else {
      const { movements, transactions } = getClassesShares();
      finalMovements = movements;
      finalTransactions = transactions;
    }
    // set movements for rollback operation
    const rollbackMovements = actualSociety.shares
      .filter((share) => share.isActive)
      .map((share) => ({
        partner: share.partner,
        shareFrom: share.from,
        shareTo: share.to,
        shareClass: share?.shareClass,
        sharePremium: share?.sharePremium,
        sharePrice: share?.sharePrice,
        movementType: DECREMENT,
      }));
    dispatch(
      reclassificationAction({
        movements: [...rollbackMovements, ...finalMovements],
        transactions: finalTransactions,
        nominalValue: actualSociety.nominalValue,
        date,
        society: actualSociety['_id'],
        user: user['_id'],
        documents: uploadedDocument?.['_id'] ? [uploadedDocument['_id']] : [],
        comments: cleanText(comments),
        notarialRegistration: {
          notaryName,
          notaryCity,
          protocolNr,
        },
      })
    );
    dispatch(setModal(null));

    trackEvent(mixpanel, eventTypes.RECLASSIFICATION, {
      userId: user?._id,
      userName: user?.name,
      userEmail: user?.email,
      societyId: actualSociety?._id,
      societyName: actualSociety?.name,
      operation: eventTypes.RECLASSIFICATION,
    });
  }

  function nextStep(event) {
    event.preventDefault();
    if (!step) {
      setStep(1);
    } else {
      saveReclassification();
    }
  }

  const handleClassOptionChange = (selectedOption, index) => {
    if (distributionType === distribution.BYPARTNER) {
      const currentShare = currentPartnerShares[index];
      if (selectedOption.value !== currentShare.shareClass?.['_id']) {
        const partner = getActualPartner(actualSociety, selectedPartner);
        if (partner) {
          const newShare = {
            ...currentShare,
            shareClass:
              holdingClasses.find(
                (holdingClass) => holdingClass['_id'] === selectedOption.value
              ) || currentShare.shareClass,
          };
          const newShares = currentPartnerShares.map((share, currIndex) =>
            index === currIndex ? newShare : share
          );
          setCurrentPartnerShares(newShares);
          const newPartnersShares = cloneDeep(partnersShares);
          newPartnersShares[partner['_id']] = newShares;
          setPartnersShares(newPartnersShares);
          const newRenumeration = {
            partner: partner.name,
            previous: {
              from: currentShare.shareFrom,
              to: currentShare.shareTo,
            },
            next: { from: currentShare.shareFrom, to: currentShare.shareTo },
            className: newShare.shareClass.name,
          };
          setRenumerations([...renumerations, newRenumeration]);
        }
      }
    }
    if (distributionType === distribution.BYCLASSES) {
      const currentShare = currentClassRanges[index];
      if (selectedOption.value !== currentShare.shareClass?.['_id']) {
        const newShare = {
          ...currentShare,
          shareClass:
            holdingClasses.find(
              (holdingClass) => holdingClass['_id'] === selectedOption.value
            ) || currentShare.shareClass,
        };
        const newShares = currentClassRanges.map((share, currIndex) =>
          index === currIndex ? newShare : share
        );
        setCurrentClassRanges(newShares);
        const newClassesRanges = cloneDeep(classesRanges);
        newClassesRanges[selectedClassOption.value] = [...newShares];
        setClassesRanges(newClassesRanges);
        const newRenumeration = {
          from: currentShare.shareFrom,
          to: currentShare.shareTo,
          previous: currentShare?.shareClass?.name || '',
          next: newShare?.shareClass?.name || '',
        };
        setRenumerations([...renumerations, newRenumeration]);
      }
    }
  };

  const handleChangeFile = (newFile) => {
    setFile(newFile);
  };

  useEffect(() => {
    if (actualSociety) {
      const excludedOps = [
        operationTypes.ADD_PARTNERS,
        operationTypes.ADD_PARTNER,
        operationTypes.ADD_BENEFICIARY,
        operationTypes.STOCK_OPTION,
        operationTypes.PHANTOM_SHARE,
      ];
      const filteredOperations = actualSociety.operations.filter(
        (operation) => !excludedOps.includes(operation.operationType)
      );
      const lastOperation = filteredOperations.reduce((acc, op) =>
        new Date(acc.date) > new Date(op.date) ? acc : op
      );
      // Get last operation date from UTC to local timezone with new Date()
      const lastDate = format(
        new Date(lastOperation.date),
        "yyyy-MM-dd'T'HH:mm"
      );
      const dateLimit = format(new Date(lastOperation.date), 'yyyy-MM-dd');
      setOperationLimit(dateLimit);
      setLastOperationDate(lastDate || '1990-01-01T00:00');
    }
  }, [actualSociety]);

  useEffect(() => {
    if (distributionType === distribution.BYCLASSES) {
      const options = holdingClasses?.map((currentClass) => ({
        value: currentClass?.['_id'],
        label: currentClass?.name,
      }));
      options.push({
        value: 'disabled',
        label: '─────────────────',
        isDisabled: true,
      });
      options.push({
        value: ANADIR_CLASE,
        label: ANADIR_CLASE,
      });
      const classesShares = holdingClasses?.reduce((acc, currClass) => {
        acc[currClass['_id']] = [];
        return acc;
      }, {});

      actualSociety?.shares?.forEach((share) => {
        if (share.isActive && share?.shareClass?.['_id']) {
          const { shareClass } = share;
          if (classesShares[shareClass['_id']]) {
            classesShares[shareClass['_id']].push({
              partner: share.partner,
              shareFrom: share.from,
              shareTo: share.to,
              shareClass: share.shareClass,
              sharePremium: share.sharePremium,
              sharePrice: share.sharePrice,
            });
          } else {
            classesShares[shareClass['_id']] = [
              {
                partner: share.partner,
                shareFrom: share.from,
                shareTo: share.to,
                shareClass: share.shareClass,
                sharePremium: share.sharePremium,
                sharePrice: share.sharePrice,
              },
            ];
          }
        }
      });
      const orderedClassesShares = Object.entries(classesShares).reduce(
        (acc, [classId, shares]) => {
          acc[classId] = shares.sort((a, b) => a.shareFrom - b.shareFrom);
          return acc;
        },
        {}
      );
      setClassesRanges(orderedClassesShares);
      setClassesOptions(options);
      setSelectedClassOption({
        value: '',
        label: t('Select'),
      });
      setRenumerations([]);
      setCreateClassInsite(false);
    } else if (distributionType === distribution.BYPARTNER) {
      const activePartners = actualSociety?.partners.filter(
        (partner) => partner?.sharesCount?.actual > 0
      );
      const options = actualSociety?.partners
        .filter((partner) => partner?.sharesCount?.actual > 0)
        .map((partner) => ({
          value: partner?.['_id'],
          label: `${partner?.cif} | ${partner?.name} | ${
            partner?.sharesCount?.actual
          } ${t('shares')}`,
        }));
      const partners = activePartners.reduce((acc, partner) => {
        const shares = actualSociety?.shares.filter(
          (share) => share.isActive && share.partner === partner['_id']
        );
        acc[partner['_id']] = shares.map((share) => ({
          shareFrom: share.from,
          shareTo: share.to,
          shareClass: share.shareClass,
          sharePremium: share.sharePremium,
          sharePrice: share.sharePrice,
        }));
        return acc;
      }, {});
      setPartnersShares(partners);
      setPartnerOptions(options);
      setRenumerations([]);
      setSelectedPartner(SELECCIONAR_SOCIO);
      setSelectedPartnerOption({
        value: SELECCIONAR_SOCIO,
        label: SELECCIONAR_SOCIO,
      });
      setCreateClassInsite(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [distributionType, holdingClasses]);

  useEffect(() => {
    if (
      selectedPartner !== SELECCIONAR_SOCIO &&
      distributionType === distribution.BYPARTNER
    ) {
      const id = selectedPartner;
      const partner = getActualPartner(actualSociety, id);
      setPartnerName(partner?.name);
      setCurrentPartnerShares(partnersShares[id]);
    }
    if (selectedPartner === SELECCIONAR_SOCIO) setCurrentPartnerShares([]);
    setEditIndex(-1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPartner]);

  useEffect(() => {
    if (
      selectedClassOption.value &&
      distributionType === distribution.BYCLASSES
    ) {
      if (selectedClassOption.value === ANADIR_CLASE) {
        setCreateClassInsite(true);
        setCurrentClassRanges([]);
      } else {
        setCurrentClassRanges(classesRanges?.[selectedClassOption.value]);
      }
    } else {
      setCurrentClassRanges([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedClassOption]);

  useEffect(() => {
    if (includeAllRanges && currentClassRanges?.length) {
      const newFixedRange = cloneDeep(fixedRange);
      const min = currentClassRanges.reduce(
        (min, curr) => (curr.shareFrom < min ? curr.shareFrom : min),
        currentClassRanges[0]?.shareFrom
      );
      const max = currentClassRanges.reduce(
        (max, curr) => (curr.shareTo > max ? curr.shareTo : max),
        currentClassRanges[0]?.shareTo
      );
      newFixedRange.from = min;
      newFixedRange.to = max;
      setFixedRange(newFixedRange);
      setIsValidRange(true);
      setValidationMessage('');
    } else {
      setFixedRange({ from: '', to: '' });
      setIsValidRange(false);
      setValidationMessage('');
    }
  }, [includeAllRanges]);

  useEffect(() => {
    if (holdingClasses?.length) {
      const initial = holdingClasses?.reduce(
        (acc, currentClass) => {
          acc.from[currentClass['_id']] = 1;
          acc.refs[currentClass['_id']] =
            currentClass.numerationOption || currentClass['_id'];
          return acc;
        },
        {
          from: {},
          refs: {},
        }
      );
      const finalRefs = Object.entries(initial.refs).reduce(
        (acc, [id, ref]) => {
          acc[id] = acc[initial.refs[ref]] || initial.refs[ref];
          return acc;
        },
        {}
      );
      setActualFrom(initial.from);
      setNumerationRefs(finalRefs);
    }
  }, [holdingClasses]);

  return (
    <>
      <Modal.Header>
        <h5 className="modal-title">{t('ReclassificationOfShares')}</h5>
        <a
          className="close cursor-pointer"
          onClick={() => dispatch(setModal(null))}
        >
          <em className="icon ni ni-cross" />
        </a>
      </Modal.Header>
      <Modal.Body>
        <form className="form-validate is-alter" onSubmit={nextStep}>
          {!step ? (
            <>
              <div className="form-group">
                <label className="form-label" htmlFor="pay-amount">
                  {t('ReclassificationDate')}
                </label>
                <div className="form-control-wrap">
                  <input
                    type="date"
                    className="form-control date-picker"
                    value={operationDate}
                    onChange={(event) => handleDate(event.target.value)}
                    required
                    max="2100-01-01"
                    min={operationLimit}
                  />
                </div>
                {errorMessage ? (
                  <span className="sub-text mt-1 text-danger">
                    {errorMessage}
                  </span>
                ) : (
                  <></>
                )}
              </div>

              <UploadDocument
                label="AddWritingOptional"
                inputLabel={file?.name || t('DragDocumentToUpload')}
                file={file}
                setFile={handleChangeFile}
              />

              <div className="form-group">
                <label className="form-label" htmlFor="operation-comments">
                  {t('CommentsLabel')}
                </label>
                <div className="form-control-wrap">
                  <div className="form-editor-custom">
                    <textarea
                      id="operation-comments"
                      maxLength="500"
                      className="form-control form-control-lg no-resize"
                      value={comments}
                      onChange={(e) => setComments(e.target.value)}
                    />
                  </div>
                </div>
                <div className="form-note d-flex justify-content-between">
                  <>{t('CommentsVisibleOnlyAdmins')}</>
                  <CommentsCharCounter comments={comments} />
                </div>
              </div>

              <div className="row mb-4">
                <div className="col-4">
                  <div className="form-group">
                    <label className="form-label">{t('NotaryName')}</label>
                    <div className="form-control-wrap">
                      <input
                        type="text"
                        className="form-control form-control-md"
                        placeholder={t('Mr. John Smith')}
                        value={notaryName}
                        onChange={(e) => setNotaryName(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="form-group">
                    <label className="form-label">
                      {t('NotaryProtocolNumber')}
                    </label>
                    <div className="form-control-wrap">
                      <input
                        type="text"
                        className="form-control form-control-md"
                        placeholder={t('P-8234290A')}
                        value={protocolNr}
                        onChange={(e) => setProtocolNr(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-4">
                  <div className="form-group">
                    <label className="form-label">{t('NotaryCity')}</label>
                    <div className="form-control-wrap">
                      <input
                        type="text"
                        className="form-control form-control-md"
                        placeholder={t('Barcelona')}
                        value={notaryCity}
                        onChange={(e) => setNotaryCity(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <button type="submit" className="btn btn-lg btn-primary">
                {t('Following')}
              </button>
            </>
          ) : (
            <>
              <div className="form-group">
                <label className="form-label" htmlFor="default-01">
                  {t('HowDoYouWantToAssignTheNe')}
                </label>
                <div className="row">
                  <div className="col-md-6">
                    <div className="custom-control custom-radio">
                      <input
                        type="radio"
                        className="custom-control-input"
                        name="dist-semi"
                        id="dist-semi"
                        value={distribution.BYCLASSES}
                        checked={distributionType === distribution.BYCLASSES}
                        onChange={(event) =>
                          setDistributionType(event.target.value)
                        }
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="dist-semi"
                      >
                        {t('ManualByClasses')}
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="custom-control custom-radio">
                      <input
                        type="radio"
                        className="custom-control-input"
                        name="dist-manual"
                        id="dist-manual"
                        value={distribution.BYPARTNER}
                        checked={distributionType === distribution.BYPARTNER}
                        onChange={(event) =>
                          setDistributionType(event.target.value)
                        }
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="dist-manual"
                      >
                        {t('ManualByPartners')}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              {distributionType === distribution.BYCLASSES && (
                <>
                  {createClassInsite ? (
                    <AddClassEmbedded
                      setSelectedClassOption={setSelectedClassOption}
                      setCreateClassInsite={setCreateClassInsite}
                    />
                  ) : (
                    <div className="form-group">
                      <label className="form-label" htmlFor="default-01">
                        {t('SelectShareclassToFilter')}
                      </label>
                      <div className="form-control-wrap mt-1">
                        <Select
                          closeMenuOnSelect
                          className="react-select"
                          value={selectedClassOption}
                          options={classesOptions}
                          components={animatedComponents}
                          onChange={(selectedOption) =>
                            setSelectedClassOption(selectedOption)
                          }
                        />
                      </div>
                    </div>
                  )}

                  {selectedClassOption.value && currentClassRanges?.length ? (
                    <div className="card card-bordered mb-3">
                      <div className="card-inner p-2">
                        <div className="form-group">
                          <label className="form-label" htmlFor="default-01">
                            {t('RangeToReclassify')}
                          </label>
                          <div className="row g-3">
                            <div className="col-3">
                              <input
                                type="number"
                                className="form-control"
                                placeholder={t('From')}
                                value={fixedRange.from}
                                onChange={(event) =>
                                  handleFixedRange(event.target.value, 'FROM')
                                }
                                onWheel={(event) => event.target.blur()}
                                min="1"
                                step="1"
                                required
                              />
                            </div>
                            <div className="col-3">
                              <input
                                type="number"
                                className="form-control"
                                placeholder={t('To')}
                                value={fixedRange.to}
                                onChange={(event) =>
                                  handleFixedRange(event.target.value, 'TO')
                                }
                                onWheel={(event) => event.target.blur()}
                                min="1"
                                step="1"
                                required
                              />
                            </div>
                            <div className="col-3">
                              <Select
                                closeMenuOnSelect
                                className="react-select"
                                value={selectedClassForFixedRange}
                                options={holdingClasses?.map(
                                  (holdingClass) => ({
                                    value: holdingClass['_id'],
                                    label: holdingClass.name,
                                  })
                                )}
                                components={animatedComponents}
                                onChange={(selectedOption) =>
                                  setSelectedClassForFixedRange(selectedOption)
                                }
                              />
                            </div>
                            <div className="col-3 d-flex justify-content-center">
                              <button
                                type="button"
                                className="btn btn-dim btn-primary"
                                disabled={
                                  !isValidRange ||
                                  selectedClassForFixedRange.value === ''
                                }
                                onClick={reclassifyFixedRange}
                              >
                                {t('Apply')}
                              </button>
                            </div>
                          </div>
                          <div className="form-group">
                            <div className="custom-control custom-control-xs custom-checkbox mt-1">
                              <input
                                type="checkbox"
                                id="checkbox-toggle"
                                className="custom-control-input"
                                value={includeAllRanges}
                                onChange={(event) =>
                                  setIncludeAllRanges(event.target.checked)
                                }
                              />
                              <label
                                className="custom-control-label m-1"
                                htmlFor="checkbox-toggle"
                              >
                                {t('IncludeAllRanges')}
                              </label>
                            </div>
                          </div>

                          {validationMessage ? (
                            <span className="sub-text mt-1 text-danger">
                              {validationMessage}
                            </span>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  {currentClassRanges.length ? (
                    <div className="form-group">
                      {currentClassRanges.map((share, index) => (
                        <>
                          <div className="form-control-wrap pb-1">
                            <div className="input-group">
                              <div className="input-group-prepend">
                                <span
                                  className="input-group-text text-primary"
                                  id="basic-addon3"
                                >
                                  {t('From')}
                                </span>
                              </div>
                              <NumberFormat
                                id="outlined-normal"
                                className="form-control form-control-outlined"
                                value={share.shareFrom}
                                readOnly
                                // eslint-disable-next-line react/jsx-props-no-spreading
                                {...numberFormat}
                              />
                              <div className="input-group-prepend">
                                <span
                                  className="input-group-text text-primary"
                                  id="basic-addon3"
                                >
                                  {t('To')}
                                </span>
                              </div>
                              <NumberFormat
                                id="outlined-normal"
                                className="form-control form-control-outlined"
                                value={share.shareTo}
                                readOnly
                                // eslint-disable-next-line react/jsx-props-no-spreading
                                {...numberFormat}
                              />
                              <Select
                                closeMenuOnSelect
                                className="react-select"
                                key={`${share?.['_id']}`}
                                value={{
                                  value: share.shareClass?.['_id'],
                                  label: share.shareClass?.name,
                                }}
                                options={holdingClasses?.map(
                                  (holdingClass) => ({
                                    value: holdingClass['_id'],
                                    label: holdingClass.name,
                                  })
                                )}
                                components={animatedComponents}
                                onChange={(selectedOption) =>
                                  handleClassOptionChange(selectedOption, index)
                                }
                              />
                            </div>
                          </div>
                        </>
                      ))}
                    </div>
                  ) : (
                    <></>
                  )}
                  {renumerations.length ? (
                    <div className="table-responsive">
                      <table className="table my-2">
                        <thead className="table-light">
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">{t('From')}</th>
                            <th scope="col">{t('To')}</th>
                            <th scope="col">{t('Class')}</th>
                            <th scope="col">{t('NewClass')}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {renumerations?.map((renumeration, index) => (
                            <tr>
                              <td>{index + 1}</td>
                              <td>
                                <NumberFormat
                                  displayType="text"
                                  value={renumeration.from}
                                  // eslint-disable-next-line react/jsx-props-no-spreading
                                  {...numberFormat}
                                />
                              </td>
                              <td>
                                <NumberFormat
                                  displayType="text"
                                  value={renumeration.to}
                                  // eslint-disable-next-line react/jsx-props-no-spreading
                                  {...numberFormat}
                                />
                              </td>
                              <td>{renumeration.previous}</td>
                              <td>{renumeration.next}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <></>
                  )}
                </>
              )}

              {distributionType === distribution.BYPARTNER && (
                <>
                  {createClassInsite ? (
                    <AddClassEmbedded
                      setSelectedClassOption={setSelectedClassOption}
                      setCreateClassInsite={setCreateClassInsite}
                    />
                  ) : (
                    <button
                      type="button"
                      className="btn btn-sm btn-dim btn-light mb-3"
                      onClick={() => setCreateClassInsite(true)}
                    >
                      <em className="icon ni ni-plus" />
                      <span>{t('AddClass')}</span>
                    </button>
                  )}

                  <div className="form-group">
                    <label className="form-label" htmlFor="default-01">
                      {t('SelectShareholderForReclass')}
                    </label>
                    <div className="form-control-wrap mt-1">
                      <Select
                        closeMenuOnSelect
                        className="react-select"
                        value={selectedPartnerOption}
                        options={partnerOptions}
                        components={animatedComponents}
                        onChange={handlePartnerOptionChange}
                      />
                    </div>
                  </div>
                  {currentPartnerShares.length ? (
                    <div className="form-group">
                      <label className="form-label" htmlFor="default-01">
                        {partnerName}
                      </label>
                      <span className="sub-text">
                        {t('ToAssignNewSectionsPressT')}&nbsp;
                        <span className="text-primary">{t('Renumber')}</span>
                      </span>
                      {currentPartnerShares.map((share, index) => (
                        <>
                          <div className="form-control-wrap pb-1">
                            <div className="input-group">
                              <div className="input-group-prepend">
                                <span
                                  className="input-group-text text-primary"
                                  id="basic-addon3"
                                >
                                  {t('From')}
                                </span>
                              </div>
                              <NumberFormat
                                id="outlined-normal"
                                className="form-control form-control-outlined"
                                value={share.shareFrom}
                                readOnly
                                // eslint-disable-next-line react/jsx-props-no-spreading
                                {...numberFormat}
                              />
                              <div className="input-group-prepend">
                                <span
                                  className="input-group-text text-primary"
                                  id="basic-addon3"
                                >
                                  {t('To')}
                                </span>
                              </div>
                              <NumberFormat
                                id="outlined-normal"
                                className="form-control form-control-outlined"
                                value={share.shareTo}
                                readOnly
                                // eslint-disable-next-line react/jsx-props-no-spreading
                                {...numberFormat}
                              />
                              <Select
                                closeMenuOnSelect
                                className="react-select"
                                key={`${share?.['_id']}`}
                                value={{
                                  value: share.shareClass?.['_id'],
                                  label: share.shareClass?.name,
                                }}
                                options={holdingClasses?.map(
                                  (holdingClass) => ({
                                    value: holdingClass['_id'],
                                    label: `${holdingClass.name}`,
                                  })
                                )}
                                components={animatedComponents}
                                onChange={(selectedOption) =>
                                  handleClassOptionChange(selectedOption, index)
                                }
                              />
                              <button
                                className="btn btn-outline-primary btn-dim border-radius-0"
                                type="button"
                                onClick={() => setEditIndex(index)}
                              >
                                <span>{t('Renumber')}</span>
                              </button>
                            </div>
                          </div>
                          {index === editIndex ? (
                            <AddNumerationEmbedded
                              setEditIndex={setEditIndex}
                              setPartnersShares={setPartnersShares}
                              setCurrentPartnerShares={setCurrentPartnerShares}
                              setRenumerations={setRenumerations}
                              partnersShares={partnersShares}
                              currentPartnerShares={currentPartnerShares}
                              renumerations={renumerations}
                              partner={getActualPartner(
                                actualSociety,
                                selectedPartner
                              )}
                              total={share.shareTo - share.shareFrom + 1}
                              shareIndex={index}
                              key={selectedPartner}
                              holdingClass={share?.shareClass}
                            />
                          ) : (
                            <></>
                          )}
                        </>
                      ))}
                    </div>
                  ) : (
                    <></>
                  )}
                  {renumerations.length ? (
                    <div className="table-responsive">
                      <table className="table my-2">
                        <thead className="table-light">
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">{t('Name')}</th>
                            <th scope="col">{t('Previous')}</th>
                            <th scope="col">{t('NewOne')}</th>
                            <th scope="col">{t('Class')}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {renumerations?.map((renumeration, index) => (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{renumeration.partner}</td>
                              <td>
                                <NumberFormat
                                  displayType="text"
                                  value={renumeration.previous.from}
                                  // eslint-disable-next-line react/jsx-props-no-spreading
                                  {...numberFormat}
                                />
                                -
                                <NumberFormat
                                  displayType="text"
                                  value={renumeration.previous.to}
                                  // eslint-disable-next-line react/jsx-props-no-spreading
                                  {...numberFormat}
                                />
                              </td>
                              <td>
                                <NumberFormat
                                  displayType="text"
                                  value={renumeration.next.from}
                                  // eslint-disable-next-line react/jsx-props-no-spreading
                                  {...numberFormat}
                                />
                                -
                                <NumberFormat
                                  displayType="text"
                                  value={renumeration.next.to}
                                  // eslint-disable-next-line react/jsx-props-no-spreading
                                  {...numberFormat}
                                />
                              </td>
                              <td>{renumeration.className}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <></>
                  )}
                </>
              )}
              <button
                type="submit"
                className="btn btn-lg btn-primary"
                disabled={!renumerations.length || distributionType === ''}
              >
                {t('Save')}
              </button>
            </>
          )}
        </form>
      </Modal.Body>
    </>
  );
}

export default ReclassificationModal;
